import React from 'react';

import GenericMessagePage from './GenericMessagePage';

export default function Page404() {
  return <GenericMessagePage text="404 Page Not Found :(" />;
}
